// CheckoutPage.jsx
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleRazorpayPayment } from './handlePayment';
import { PartenerSheepDeedService } from './parternshipservice';
import AuthUser from "../services/AuthUser";
import { ServicesContext } from '../services/ServicesContext';
import StepProgress from '../view/New/StepProgress';



const CheckoutPage = () => {
    const { http, token } = AuthUser();
    const [coupons, setCoupons] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const { service } = location.state || {};
    const [formData, setFormData] = useState({});
    const [coupon, setCoupon] = useState('');
    const [discount, setDiscount] = useState(0);
    const [baseAmount, setBaseAmount] = useState(0); // Default price
    const [finalAmount, setFinalAmount] = useState(0);
    const [error, setError] = useState(null);

    const currentStep = 0; // Change this dynamically as needed (0-based)

    console.log("coupons", coupons);


    useEffect(() => {
        const fetchCoupons = async () => {
            try {
                const response = await http.get("/get-coupons");
                setCoupons(response.data);
            } catch (err) {
                setError("Failed to load coupons.");
            }
        };

        fetchCoupons();
    }, []);


    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem('bookingData'));
        if (!stored) return navigate('/');
        setFormData(stored);

        const servicePrice = stored?.prize || stored?.planprice || service?.price;
        setBaseAmount(servicePrice);
        setFinalAmount(servicePrice);
    }, []);

    const applyCoupon = () => {
        const trimmedCode = coupon.trim().toUpperCase();
        const today = new Date();
        today.setHours(0, 0, 0, 0); // normalize to midnight

        const matched = coupons.find(c => {
            if (!c.coupon_title || c.coupon_title.toUpperCase() !== trimmedCode) return false;
            if (c.coupon_status !== 'Publish') return false;

            const startDate = new Date(c.coupon_validate);
            const expireDate = new Date(c.coupon_expire_date);
            startDate.setHours(0, 0, 0, 0);
            expireDate.setHours(0, 0, 0, 0);

            // Check if today is between start and expire dates (inclusive)
            return today >= startDate && today <= expireDate;
        });

        if (matched) {
            const discountPercent = parseFloat(matched.coupon_discount) || 0;
            const discountAmount = (baseAmount * discountPercent) / 100;
            setDiscount(discountAmount);
            setFinalAmount(baseAmount - discountAmount);
            alert(`Coupon "${matched.coupon_title}" applied! ${discountPercent}% discount (${discountAmount.toFixed(2)})`);
        } else {
            alert('Invalid or expired coupon code');
            setDiscount(0);
            setFinalAmount(baseAmount);
        }
    };

    const serviceMap = {
        1: PartenerSheepDeedService.partenerShipDeedForm,
        2: PartenerSheepDeedService.pvtLtdCompanyRegistionForm,
        4: PartenerSheepDeedService.sectionEightRegistionForm,
        5: PartenerSheepDeedService.llpRegistionForm,
        6: PartenerSheepDeedService.opcCompanyRegistionForm,
        7: PartenerSheepDeedService.annualComplainForm, // LLP
        8: PartenerSheepDeedService.annualComplainPvtLtdForm,
        9: PartenerSheepDeedService.IECForm,
        10: PartenerSheepDeedService.msmeForm,
        11: PartenerSheepDeedService.gumstaLincesForm,
        12: PartenerSheepDeedService.trademarkLincesForm,
        13: PartenerSheepDeedService.gstRegistraionForm,
        14: PartenerSheepDeedService.foodLincenceForm,
        15: PartenerSheepDeedService.gstReturnForm,
        16: PartenerSheepDeedService.itrFilingForm,
        17: PartenerSheepDeedService.tdsReturnForm,
        18: PartenerSheepDeedService.onlineAccountingForm,
        19: PartenerSheepDeedService.legalNoticeReplyForm,
        20: PartenerSheepDeedService.legalAdviceForm,
        21: PartenerSheepDeedService.legalNoticeForm,

        35: PartenerSheepDeedService.cmaReport,
        36: PartenerSheepDeedService.Dissolution,
        37: PartenerSheepDeedService.addressAmendmentLLP,
        38: PartenerSheepDeedService.addressAmendmentCompany,
        39: PartenerSheepDeedService.addressAmendmentOutOfStateLLP,
        40: PartenerSheepDeedService.addressAmendmentOutOfStateCompany,
        41: PartenerSheepDeedService.addDirectorCompany,
        42: PartenerSheepDeedService.removeDirectorCompany,
        43: PartenerSheepDeedService.addPartnerCompany,
        44: PartenerSheepDeedService.removePartnerLLP,
        45: PartenerSheepDeedService.increaseCapitalLLP,
        46: PartenerSheepDeedService.increaseCapitalCompany,
        47: PartenerSheepDeedService.changeNameLLP,
        48: PartenerSheepDeedService.changeNameCompany,
        49: PartenerSheepDeedService.societyForm,
        50: PartenerSheepDeedService.pfAndEsicRegistration,
        51: PartenerSheepDeedService.professionalTaxForm,
        52: PartenerSheepDeedService.balanceSheetPL,
        53: PartenerSheepDeedService.drafting,
        54: PartenerSheepDeedService.pfEsicReturn,
    };


    const handleSubmit = async (paymentData = null) => {

        console.log("paymentData:", paymentData);

        // Get agent object from local storage
        const agentData = localStorage.getItem("agent");

        // Parse the JSON string to an object
        let uniqId = "";
        if (agentData) {
            const agent = JSON.parse(agentData); // Convert string to JSON object
            uniqId = agent.user_id; // Extract uniq_id
        }

        // Step 2: Prepare form data (from either form input or Razorpay callback)
        let finalPayload;

        if (paymentData) {
            // Called after Razorpay payment success
            finalPayload = {
                ...paymentData,
                agent_id: uniqId,
                select_tenure: JSON.stringify({
                    transactions: paymentData.transactions,
                    accounting: paymentData.accounting,
                    accountingFor: paymentData.accountingFor,
                }),
            };
        } else {
            // Called normally via form submit
            const updatedFormData = { ...formData, agent_id: uniqId };

            finalPayload = {
                ...updatedFormData,
                select_tenure: JSON.stringify({
                    transactions: formData.transactions,
                    accounting: formData.accounting,
                    accountingFor: formData.accountingFor,
                }),
            };
        }





       

        try {

            const response = await http.post("/book-service", finalPayload, {
                headers: {
                    "Content-Type": "application/json", // Ensure correct content type
                }
            });

            // alert("Service booked successfully!");
            navigate('/upload-documents');


        } catch (error) {
            console.error("Error submitting form:", error.response?.data || error.message);

            let errorMessage = "Failed to book service!";

            if (error.response && error.response.data) {
                const errors = error.response.data.errors;

                if (errors) {
                    // Prioritize service error if it exists
                    if (errors.serviceset && errors.serviceset.length > 0) {
                        errorMessage = errors.serviceset[0];
                    } else if (errors.city && errors.city.length > 0) {
                        errorMessage = errors.city[0];
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                } else if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            }

            alert(errorMessage);
        }
    };


    const handlePayNow = async () => {

        const agentData = localStorage.getItem("agent");
        const isAgent = !!agentData;
        await handleRazorpayPayment({
            amount: finalAmount,
            service: service,
            userData: formData,
            http,
            fieldMap: {
                email: 'user_email' || 'user_email_address'||"email",
                contact: 'user_contact_number' || 'user_phone_number' || 'user_contact' || 'user_phone' ||'phone_number',
                name: 'user_name'||'name'
            },
            formSubmitCallback: isAgent ? handleSubmit :  async (mergedData) => {
                try {

                    const submitFunction = serviceMap[service.service_id];

                    if (!submitFunction) {
                        alert('Service submission not configured!');
                        return;
                    }
                    const response = await submitFunction(mergedData);

                    if (response.data && response.data.razorpay_payment_id) {

                        navigate('/upload-documents');
                    } else {
                        alert('Failed to submit the form. Please try again.');
                        console.error('Form submission failed:', response);
                    }
                } catch (error) {
                    alert('An error occurred while submitting the form.');
                    console.error('Error during form submission:', error);
                }
            },
        });
    };


    return (

        <div className="hero-area10 header-background min-vh-100">
            <div className="container py-4 mt-4">
                {/* Progress Steps */}
                <div className=' d-flex justify-content-center align-items-center mb-5 position-relative'>
                    <img className='process-img' src="assets/new/process-01.png" alt="" srcset="" />
                </div>

                {/* Main Section */}
                <div className="row m-4 justify-content-center check-out-main">
                    {/* Left Side Info */}
                    <div className="col-md-6 mb-4">

                        <h1
                            className="sk-text-color mb-3 check-out-head"

                        >
                            Review your order
                        </h1>


                        <div className="mt-4">
                            <h5>User Information:</h5>
                            <p><strong>Name:</strong> {formData.user_name || formData.name}</p>
                            <p><strong>Email:</strong> {formData.user_email || formData.user_email_address || formData.email}</p>
                            <p><strong>Contact:</strong> {
                                formData.user_contact_number ||
                                formData.user_phone_number ||
                                formData.phone_number ||
                                formData.user_contact ||
                                formData.user_phone
                            }</p>

                            {/* <p><strong>City:</strong> {formData.city}</p> */}
                        </div>
                    </div>

                    {/* Right Side Summary */}
                    <div
                        className="col-md-5 p-4"
                        style={{
                            backgroundColor: '#fff',
                            // border: '2px solid #00a6ff',
                            borderRadius: '10px',
                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',

                        }}
                    >

                        <h5 className="border-bottom pb-2 mb-3">Order Details:</h5>
                        <div className="container" style={{ paddingLeft: '10px' }}>
                            <div className="row">
                                <div className="col-5">
                                    <p className="serviceregistername">Service:</p>
                                </div>
                                <div className="col-7">
                                    <p className="serviceregistername">{service?.service_name}</p>
                                </div>

                                <div className="col-5">
                                    <p className="serviceregistername2">Plan:</p>
                                </div>
                                <div className="col-7">
                                    <p className="serviceregistername2">{formData.plans?.trim() ? formData.plans : '-'}</p>
                                </div>

                                <div className="col-5">
                                    <p className="serviceregistername2">Price:</p>
                                </div>
                                <div className="col-7">
                                    <p className="serviceregistername2">
                                        ₹{baseAmount.toFixed(2)}
                                    </p>
                                </div>

                                <div className="col-5">
                                    <p className="serviceregistername2">GST (0%):</p>
                                </div>
                                <div className="col-7">
                                    <p className="serviceregistername2">₹{(baseAmount * 0).toFixed(2)}</p>
                                </div>

                                {discount > 0 && (
                                    <>
                                        <div className="col-5">
                                            <p className="serviceregistername2">Coupon Discount:</p>
                                        </div>
                                        <div className="col-7">
                                            <p className="serviceregistername2 text-danger">-₹{discount}</p>
                                        </div>
                                    </>
                                )}

                                <div className="col-5">
                                    <p className="serviceregistername2">Apply coupon code:</p>
                                </div>
                                <div className="col-7">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Coupon Code"
                                            value={coupon}
                                            onChange={(e) => setCoupon(e.target.value)}
                                            style={{ textTransform: 'uppercase' }}
                                        />
                                        <button className="btn btn-outline-primary" onClick={applyCoupon}>
                                            Apply
                                        </button>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <p className="fs-5 fw-bold mt-3">Total: ₹{(finalAmount + baseAmount * 0).toFixed(2)}</p>
                                </div>

                                <div className="col-12">
                                    <button
                                        className="theme-btn-3 btn-hover w-100 fw-semibold"
                                        onClick={handlePayNow}
                                    >
                                        PAY NOW ➞
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    );
};

export default CheckoutPage;


